import { ErrorsService } from "src/app/services/common/errors.service";
import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDialog
} from "@angular/material";

import { ITermInfo } from "src/app/interfaces/term-info";
import { TermInfoService } from "src/app/services/http/business/term-info/term-info.service";
import { TermInfoEntryComponent } from "../term-info-entry/term-info-entry.component";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { TermInfoSearchComponent } from "../term-info-search/term-info-search.component";

@Component({
  selector: "app-term-info-list",
  templateUrl: "./term-info-list.component.html",
  styleUrls: ["./term-info-list.component.css"]
})
export class TermInfoListComponent implements OnInit {
  companySelected: string;
  companyList: ICompany[];
  filter:any;
  displayedColumns: string[] = [
    this.translate.get("label.termName"),
    this.translate.get("label.year"),
    this.translate.get("label.termType"),
    this.translate.get("label.termNumber"),
    this.translate.get("label.parrentTerm"),
    this.translate.get("label.startTime"),
    this.translate.get("label.endTime"),
    "confirm",
    "closed",
    "function"
  ];
  dataSource = new MatTableDataSource();
  term: ITermInfo;
  isOwner: boolean;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private termInfoService: TermInfoService
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.termInfoService.close.subscribe(() => {
      this.companySelected = this.cidService.getCID();
      this.getCompanyList();
      this.loadTerms(this.companySelected);
    });
    this.companySelected = this.cidService.getCID();
    this.loadTerms(this.companySelected);
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  loadTerms(e: any) {
    this.cidService.setCID(e);
    this.getTermInfoList();
  }

  getTermInfoList() {
    this.termInfoService.list(this.filter).subscribe(res => {
      this.dataSource = new MatTableDataSource<ITermInfo>(res.DataList);
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }
  paginatorEvent(event) {
    this.termInfoService
      .list(this.filter, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  search(){
    this.dialog
      .open(TermInfoSearchComponent, {
        width: "500px",
      })
      .afterClosed()
      .subscribe(
        res => {
          console.log(res);
          this.filter = res;
          this.termInfoService.list(res).subscribe(re => {
            this.paginator.pageIndex = 0;
            this.dataSource = re.DataList;
            this.paginator.length = re.Total;
          });
        },
        () => {
          this.errorService.transactionError();
        }
      );
  }

  add() {
    this.dialog
      .open(TermInfoEntryComponent, {
        height: "95%",
        width: "950px",
      })
      .afterClosed()
      .subscribe(
        () => {
          this.termInfoService.closeModal();
          this.termInfoService.list(this.filter).subscribe(re => {
            this.paginator.pageIndex = 0;
            this.dataSource = re.DataList;
            this.paginator.length = re.Total;
          });
        },
        () => {
          this.errorService.transactionError();
        }
      );
  }

  edit(data: ITermInfo) {
    this.dialog
      .open(TermInfoEntryComponent, {
        height: "95%",
        width: "950px",
        data: data
      })
      .afterClosed()
      .subscribe(
        () => {
          this.getTermInfoList();
        },
        () => {
          this.errorService.transactionError();
        }
      );
  }

  toggleTerm(data: ITermInfo) {
    this.term = data;
    let confirm: IConfirm;
    if (data.Closed) {
      confirm = {
        accept: true,
        message: this.translate.get("confirm.openTerm", {
          name: this.translate.get("label.term") + " " + data.Title
        }),
        alert: null,
        yesLabel: this.translate.get("label.yes"),
        noLabel: this.translate.get("label.no")
      };
    }
    else {
      confirm = {
        accept: true,
        message: this.translate.get("confirm.closeTerm", {
          name: this.translate.get("label.term") + " " + data.Title
        }),
        alert: null,
        yesLabel: this.translate.get("label.yes"),
        noLabel: this.translate.get("label.no")
      };
    }


    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.termInfoService.ToggleTerm(this.term).subscribe(
          () => {
            this.getTermInfoList();
          },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }

  toConfirmTerm(data: ITermInfo) {
    this.term = data;
    let confirm: IConfirm;

    confirm = {
      accept: true,
      message: this.translate.get("confirm.confirmTerm", {
        name: this.translate.get("label.term") + " " + data.Title
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };


    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.termInfoService.ToConfirmTerm(this.term).subscribe(
          () => {
            this.getTermInfoList();
          },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }


  delete(data: ITermInfo) {
    this.term = data;
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.term") + " " + data.Title
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.termInfoService.delete(this.term).subscribe(
          () => {
            this.getTermInfoList();
          },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }

  // ngOnDestroy() {
  //   if (this.isOwner) this.cidService.setCID("");
  // }
}
